import { mdiClipboardAccountOutline } from '@mdi/js'

export default {
  title: 'Hob',
  to: 'hob-list',
  icon: mdiClipboardAccountOutline,
  resource: 'HobHeadDepartment',
  action: 'read',
}
